
export default function Security() {
  const securityFeatures = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Certificación ISO 27001',
      description: 'Gestión de seguridad de la información certificada internacionalmente'
    },
    {
      icon: 'ri-lock-fill',
      title: 'Cifrado SSL 256-bit',
      description: 'Protección de nivel bancario en todas las transacciones y comunicaciones'
    },
    {
      icon: 'ri-file-shield-2-fill',
      title: 'Cumplimiento KYC/AML',
      description: 'Procesos de identificación y prevención de lavado de activos'
    },
    {
      icon: 'ri-database-2-fill',
      title: 'Almacenamiento Seguro',
      description: 'Servidores certificados con respaldo y recuperación de datos'
    },
    {
      icon: 'ri-eye-off-fill',
      title: 'Privacidad Garantizada',
      description: 'No compartimos tu información sin tu consentimiento expreso'
    },
    {
      icon: 'ri-audit-fill',
      title: 'Auditorías Regulares',
      description: 'Revisiones periódicas por organismos reguladores independientes'
    },
  ];

  const regulations = [
    { country: 'Chile', law: 'Ley 19.628', entity: 'CMF' },
    { country: 'Perú', law: 'Ley 29733', entity: 'SBS' },
    { country: 'México', law: 'LFPDPPP', entity: 'CNBV' },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-emerald-600/20 border border-emerald-500/30 rounded-full px-5 py-2 mb-6">
            <i className="ri-shield-star-fill text-emerald-400"></i>
            <span className="text-sm text-emerald-300 font-medium">Seguridad y Cumplimiento</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Tu Seguridad es Nuestra Prioridad
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Operamos bajo los más altos estándares de seguridad y cumplimiento normativo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {securityFeatures.map((feature, index) => (
            <div key={index} className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 hover:bg-white/10 transition-all">
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
              <p className="text-slate-300 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
          <h3 className="text-2xl font-bold mb-8 text-center">Cumplimiento Normativo por País</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {regulations.map((reg, index) => (
              <div key={index} className="bg-white/5 rounded-lg p-6 text-center border border-white/10">
                <h4 className="text-xl font-bold text-emerald-400 mb-3">{reg.country}</h4>
                <p className="text-sm text-slate-300 mb-2">{reg.law}</p>
                <p className="text-xs text-slate-400">Supervisado por {reg.entity}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
